export default {
  roundOnly: true,
  checkoutFormVariant: 'd',
  planSet: 'pricing-33',
  growthbookFeatures: ['supp', 'thankyou_tips'],
  sexologyUpsellEnabled: false,
};
